import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { getTeamMembers, getSiteConfig } from '../services/api';
import { FaFacebook, FaInstagram, FaTiktok } from 'react-icons/fa';

function getVideoInfo(url) {
  if (!url) return null;
  const yt = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
  if (yt) return { type: 'iframe', src: `https://www.youtube.com/embed/${yt[1]}`, platform: 'youtube', thumb: `https://img.youtube.com/vi/${yt[1]}/hqdefault.jpg` };
  if (url.includes('youtube.com/embed/')) return { type: 'iframe', src: url, platform: 'youtube' };
  const vimeo = url.match(/vimeo\.com\/(\d+)/);
  if (vimeo) return { type: 'iframe', src: `https://player.vimeo.com/video/${vimeo[1]}`, platform: 'vimeo' };
  const tiktok = url.match(/tiktok\.com\/@[^/]+\/video\/(\d+)/);
  if (tiktok) return { type: 'iframe', src: `https://www.tiktok.com/embed/v2/${tiktok[1]}`, platform: 'tiktok' };
  return { type: 'video', src: url, platform: 'upload' };
}

const PLATFORM_COLORS = { youtube: 'bg-red-600', tiktok: 'bg-black', vimeo: 'bg-blue-500', upload: 'bg-gray-700' };
const PLATFORM_LABELS = { youtube: 'YouTube', tiktok: 'TikTok', vimeo: 'Vimeo', upload: 'Vidéo' };

function AboutUs() {
  const [members, setMembers] = useState([]);
  const [config, setConfig] = useState(null);
  const [reviewVideos, setReviewVideos] = useState([]);
  const [videoPopup, setVideoPopup] = useState({ open: false, index: 0 });
  const [tiktokThumbs, setTiktokThumbs] = useState({});
  const [popupPlaying, setPopupPlaying] = useState(false);

  useEffect(() => {
    getTeamMembers().then(res => setMembers(res.data)).catch(err => console.error(err));
    getSiteConfig().then(res => {
      setConfig(res.data);
      try { setReviewVideos(res.data.reviewVideoUrls ? JSON.parse(res.data.reviewVideoUrls) : []); } catch { setReviewVideos([]); }
    }).catch(err => console.error(err));
  }, []);

  useEffect(() => {
    if (window.location.hash === '#avis-clients' && reviewVideos.length > 0) {
      requestAnimationFrame(() => {
        const el = document.getElementById('avis-clients');
        if (el) {
          const top = el.getBoundingClientRect().top + window.scrollY - 90;
          window.scrollTo({ top, behavior: 'smooth' });
        }
      });
    }
  }, [reviewVideos]);

  useEffect(() => {
    reviewVideos.forEach(url => {
      if (!url) return;
      const tiktok = url.match(/tiktok\.com\/@[^/]+\/video\/(\d+)/);
      if (tiktok && !tiktokThumbs[url]) {
        fetch(`https://www.tiktok.com/oembed?url=${encodeURIComponent(url)}`)
          .then(r => r.json())
          .then(data => { if (data.thumbnail_url) setTiktokThumbs(prev => ({ ...prev, [url]: data.thumbnail_url })); })
          .catch(() => {});
      }
    });
  }, [reviewVideos]);

  return (
    <div className="bg-white min-h-screen">
      <Header />

      <div className="max-w-7xl mx-auto px-4 py-16">

<div className="text-center mb-16">
  <h1 className="text-5xl font-extrabold text-black mb-4">
    Qui sommes <span className="text-yellow-500">nous</span> ?
  </h1>
  <div className="w-24 h-1 bg-yellow-500 mx-auto mb-8"></div>
</div>

<div className="grid grid-cols-1 lg:grid-cols-3 gap-20 mb-16 items-center">
<div className="lg:col-span-1 flex flex-col items-center justify-center">
  {config && config.logoUrl ? (
    <img src={config.logoUrl} alt="Logo" className="w-full h-100 object-contain" />
  ) : (
    <span className="text-5xl font-extrabold tracking-widest uppercase text-black text-center">
      ROYAL <span className="text-yellow-500">CARS</span>
    </span>
  )}
</div>

  <div className="lg:col-span-1">
    <h2 className="text-3xl font-bold text-black mb-6">Notre histoire</h2>
    {config && config.aboutDescription ? (
      <p className="text-gray-600 leading-relaxed text-lg whitespace-pre-line">
        {config.aboutDescription}
      </p>
    ) : (
      <p className="text-gray-400 italic">Aucune description pour le moment.</p>
    )}
  </div>

  <div className="lg:col-span-1 grid grid-cols-2 gap-4">
    {[
      { chiffre: config?.statVehiclesVendus || '500+', label: 'Véhicules vendus' },
      { chiffre: config?.statAnneesExperience || '10+', label: "Années d'expérience" },
      { chiffre: config?.statClientsSatisfaits || '98%', label: 'Clients satisfaits' },
      { chiffre: config?.statMarquesDisponibles || '50+', label: 'Marques disponibles' },
    ].map(item => (
      <div key={item.label} className="bg-gray-50 border border-gray-200 rounded-2xl p-4 text-center">
        <p className="text-yellow-500 text-3xl font-extrabold mb-1">{item.chiffre}</p>
        <p className="text-gray-600 font-medium text-sm">{item.label}</p>
      </div>
    ))}
  </div>
</div>

        <div className="mb-16">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-black mb-4">
              Notre <span className="text-yellow-500">équipe</span>
            </h2>
            <p className="text-gray-500">Des professionnels passionnés à votre service</p>
          </div>

          {members.length === 0 ? (
            <p className="text-center text-gray-400">Aucun membre pour le moment.</p>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
              {members.map(member => (
                <div key={member.id} className="bg-white border border-gray-200 rounded-2xl shadow-sm hover:shadow-md transition p-6 flex flex-col items-center text-center">
                  {member.photoUrl ? (
                    <img src={member.photoUrl} alt={`${member.prenom} ${member.nom}`} className="w-28 h-28 rounded-full object-cover mb-4 border-4 border-yellow-500" />
                  ) : (
                    <div className="w-28 h-28 rounded-full bg-gray-100 flex items-center justify-center text-5xl mb-4">👤</div>
                  )}
                  <h3 className="text-black font-bold text-lg">{member.prenom} {member.nom}</h3>
                  <p className="text-yellow-500 font-semibold text-sm mt-1">{member.poste}</p>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Avis clients vidéos */}
        {reviewVideos.length > 0 && (
          <div id="avis-clients" className="mb-16">
            <div className="text-center mb-12">
              <p className="text-yellow-500 text-sm font-bold uppercase tracking-widest mb-2">Ils nous font confiance</p>
              <h2 className="text-3xl font-bold text-black mb-3">
                Avis de nos <span className="text-yellow-500">clients</span>
              </h2>
              <div className="flex justify-center gap-1 mb-4">
                {[...Array(5)].map((_, i) => <span key={i} className="text-yellow-500 text-xl">★</span>)}
              </div>
              <p className="text-gray-500">Ce que nos clients pensent de nous</p>
            </div>

            <div className="flex gap-4 overflow-x-auto pb-3" style={{ scrollbarWidth: 'thin', scrollbarColor: '#eab308 #f3f4f6' }}>
              {reviewVideos.map((url, index) => {
                const info = getVideoInfo(url);
                const thumb = info?.thumb || (info?.platform === 'tiktok' ? tiktokThumbs[url] : null);
                return (
                  <div key={index}
                    className="relative rounded-2xl overflow-hidden cursor-pointer group shadow-md hover:shadow-xl transition-all duration-300 bg-gray-900 flex-shrink-0"
                    style={{ width: '200px', height: '320px' }}
                    onClick={() => setVideoPopup({ open: true, index })}
                  >
                    {thumb ? (
                      <img src={thumb} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 opacity-80" />
                    ) : info?.platform === 'upload' ? (
                      <video src={url} className="w-full h-full object-cover" preload="metadata" muted playsInline />
                    ) : (
                      <div className="w-full h-full flex flex-col items-center justify-center gap-3 bg-gradient-to-br from-gray-800 to-gray-900">
                        {info?.platform === 'tiktok' && (
                          <svg viewBox="0 0 24 24" className="w-14 h-14 text-white opacity-60" fill="currentColor">
                            <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.69a8.18 8.18 0 004.78 1.52V6.78a4.85 4.85 0 01-1.01-.09z"/>
                          </svg>
                        )}
                        {info?.platform === 'vimeo' && <span className="text-5xl">🎬</span>}
                      </div>
                    )}
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-black/20 group-hover:from-black/50 transition-all duration-300" />
                    <div className="absolute inset-0 flex items-center justify-center">
                      <div className="w-14 h-14 rounded-full bg-white/20 border-2 border-white/60 flex items-center justify-center group-hover:bg-yellow-500 group-hover:border-yellow-500 transition-all duration-300 backdrop-blur-sm">
                        <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 text-white ml-1" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M8 5v14l11-7z"/>
                        </svg>
                      </div>
                    </div>
                    <div className="absolute bottom-3 left-3">
                      <span className={`${PLATFORM_COLORS[info?.platform] || 'bg-gray-700'} text-white text-xs font-bold px-2 py-1 rounded-full`}>
                        {PLATFORM_LABELS[info?.platform] || 'Vidéo'}
                      </span>
                    </div>
                    <div className="absolute top-3 right-3">
                      <span className="text-yellow-400 text-xs font-bold">★★★★★</span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* Popup vidéo */}
        {videoPopup.open && (
          <div className="fixed inset-0 z-50 flex flex-col items-center justify-center p-4"
            style={{ background: 'rgba(0,0,0,0.95)', backdropFilter: 'blur(8px)' }}
            onClick={() => { setVideoPopup({ open: false, index: 0 }); setPopupPlaying(false); }}>

            {/* Flèche gauche */}
            {reviewVideos.length > 1 && (
              <button
                className="absolute left-4 top-1/2 -translate-y-1/2 w-12 h-12 rounded-full bg-white/10 border border-white/20 text-white text-3xl flex items-center justify-center hover:bg-yellow-500 hover:text-black transition z-20"
                onClick={e => { e.stopPropagation(); setPopupPlaying(false); setVideoPopup(p => ({ ...p, index: p.index === 0 ? reviewVideos.length - 1 : p.index - 1 })); }}>
                &#8249;
              </button>
            )}

            {/* Flèche droite */}
            {reviewVideos.length > 1 && (
              <button
                className="absolute right-4 top-1/2 -translate-y-1/2 w-12 h-12 rounded-full bg-white/10 border border-white/20 text-white text-3xl flex items-center justify-center hover:bg-yellow-500 hover:text-black transition z-20"
                onClick={e => { e.stopPropagation(); setPopupPlaying(false); setVideoPopup(p => ({ ...p, index: p.index === reviewVideos.length - 1 ? 0 : p.index + 1 })); }}>
                &#8250;
              </button>
            )}

            <div className="relative flex flex-col items-center w-full max-w-lg" onClick={e => e.stopPropagation()}>
              <button onClick={() => { setVideoPopup({ open: false, index: 0 }); setPopupPlaying(false); }}
                className="absolute -top-12 right-0 w-10 h-10 rounded-full bg-white/10 border border-white/20 text-white text-xl font-bold flex items-center justify-center hover:bg-yellow-500 hover:text-black transition">×</button>
              {(() => {
                const url = reviewVideos[videoPopup.index];
                const info = getVideoInfo(url);
                if (info?.type === 'video') {
                  return <video src={info.src} controls autoPlay className="w-full rounded-2xl max-h-[80vh]" />;
                }
                if (info?.platform === 'tiktok') {
                  const thumb = tiktokThumbs[url];
                  return (
                    <div className="relative w-full rounded-2xl overflow-hidden shadow-2xl bg-gray-900" style={{ aspectRatio: '9/16', maxHeight: '70vh' }}>
                      {popupPlaying ? (
                        <iframe src={info?.src} title="Avis client" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen className="w-full h-full" />
                      ) : (
                        <>
                          {thumb ? (
                            <img src={thumb} alt="Avis client" className="w-full h-full object-cover" />
                          ) : (
                            <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-gray-800 to-black">
                              <svg viewBox="0 0 24 24" className="w-20 h-20 text-white opacity-40" fill="currentColor">
                                <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.69a8.18 8.18 0 004.78 1.52V6.78a4.85 4.85 0 01-1.01-.09z"/>
                              </svg>
                            </div>
                          )}
                          <div className="absolute inset-0 bg-black/20 flex items-center justify-center cursor-pointer" onClick={() => setPopupPlaying(true)}>
                            <div className="w-20 h-20 rounded-full bg-white/20 border-2 border-white/80 flex items-center justify-center hover:bg-yellow-500 hover:border-yellow-500 transition-all duration-300 backdrop-blur-sm">
                              <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8 text-white ml-1" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M8 5v14l11-7z"/>
                              </svg>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  );
                }
                return (
                  <div className="w-full rounded-2xl overflow-hidden shadow-2xl" style={{ aspectRatio: '16/9' }}>
                    <iframe src={info?.src} title="Avis client" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen className="w-full h-full" />
                  </div>
                );
              })()}
              {reviewVideos.length > 1 && (
                <div className="flex items-center gap-2 mt-4 overflow-x-auto pb-1 w-full max-w-lg" style={{ scrollbarWidth: 'none' }}>
                  {reviewVideos.map((vurl, i) => {
                    const vinfo = getVideoInfo(vurl);
                    const vthumb = vinfo?.thumb || (vinfo?.platform === 'tiktok' ? tiktokThumbs[vurl] : null);
                    const isActive = i === videoPopup.index;
                    return (
                      <div key={i}
                        onClick={() => { setPopupPlaying(true); setVideoPopup({ open: true, index: i }); }}
                        className={`flex-shrink-0 rounded-xl overflow-hidden cursor-pointer transition-all duration-200 ${isActive ? 'ring-2 ring-yellow-500 opacity-100' : 'opacity-50 hover:opacity-80'}`}
                        style={{ width: '56px', height: '80px', background: '#1a1a1a' }}
                      >
                        {vthumb ? (
                          <img src={vthumb} alt="" className="w-full h-full object-cover" />
                        ) : vinfo?.platform === 'upload' ? (
                          <video src={vurl} className="w-full h-full object-cover" preload="metadata" muted playsInline />
                        ) : (
                          <div className={`w-full h-full flex items-center justify-center ${PLATFORM_COLORS[vinfo?.platform] || 'bg-gray-800'}`}>
                            <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 text-white" viewBox="0 0 24 24" fill="currentColor">
                              <path d="M8 5v14l11-7z"/>
                            </svg>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        )}

        <div className="rounded-2xl px-10 py-10 text-center" style={{ background: '#0d0d0d' }}>
          <h2 className="text-3xl font-bold text-white mb-3">Prêt à trouver votre véhicule ?</h2>
          <p className="text-gray-400 mb-8">Notre équipe est disponible pour vous accompagner dans votre projet</p>
          <div className="flex justify-center gap-4 flex-wrap">
            {config?.phone && (
              <a href={`tel:${config.phone}`} className="flex items-center gap-2 bg-yellow-500 text-black px-8 py-4 rounded-xl font-bold text-lg hover:bg-yellow-400 transition">
                📞 Nous appeler
              </a>
            )}
            {config?.whatsapp && (
              <a href={`https://wa.me/${config.whatsapp.replace(/\D/g, '')}`} target="_blank" rel="noreferrer" className="flex items-center gap-2 bg-green-500 border-2 border-green-500 text-white px-8 py-4 rounded-xl font-bold text-lg hover:bg-green-600 transition">
                <svg viewBox="0 0 24 24" className="w-5 h-5" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
                WhatsApp
              </a>
            )}
            {config?.facebook && (
              <a href={config.facebook} target="_blank" rel="noreferrer" className="flex items-center gap-2 bg-blue-600 border-2 border-blue-600 text-white px-8 py-4 rounded-xl font-bold text-lg hover:bg-blue-700 transition">
                <FaFacebook className="w-5 h-5" /> Facebook
              </a>
            )}
            {config?.instagram && (
              <a href={config.instagram} target="_blank" rel="noreferrer" className="flex items-center gap-2 border-2 border-pink-500 text-white px-8 py-4 rounded-xl font-bold text-lg hover:opacity-90 transition"
                style={{ background: 'linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888)' }}>
                <FaInstagram className="w-5 h-5" /> Instagram
              </a>
            )}
            {config?.tiktok && (
              <a href={config.tiktok} target="_blank" rel="noreferrer" className="flex items-center gap-2 bg-black border-2 border-white text-white px-8 py-4 rounded-xl font-bold text-lg hover:opacity-90 transition">
                <FaTiktok className="w-5 h-5" /> TikTok
              </a>
            )}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default AboutUs;